export * from './coverage';
export * from './emailCampaign';
export * from './funnel';
export * from './keyMetrics';
export * from './userAcquitition';
export * from './websiteVisits';

export enum Channel {
  VISITS_1_TO_1 = '1to1visits',
  EMAIL = 'email',
  EVENT = 'event',
  WEBSITE = 'website',
}

export enum VisitType {
  ALL = 'all',
  FACE_TO_FACE = 'Face to Face',
  PHONE = 'Phone',
  REMOTE_VISIT = 'Online Visit',
  EMAIL_MANUAL = 'Email manual',
  MESSAGE_MANUAL = 'Message manual',
  FAX = 'Fax',
  OTHER = 'Other',
}

export enum EmailAction {
  SENT = 'sent',
  OPENED = 'opened',
  CLICKED = 'clicked',
  BOUNCED = 'bounced',
}

export enum WebsiteAction {
  countHitID = 'countHitID',
  weight = 'weight',
  timeOnPage = 'timeOnPage',
}

export enum InteractionChannel {
  EMAIL = 'Email',
  EVENT = 'Event',
  WEBSITE = 'Roche Website',
  VISITS_1_TO_1 = '1to1visits',
}

export enum EventAction {
  EVENT_TYPE = 'eventType',
  NAME = 'name',
  TYPE = 'type',
  START_DATE = 'eventStartDate',
  INI_FLAG = 'initiatedFlag',
  NO_OF_GUESTS = 'attendance',
  NO_OF_INVITATIONS = 'noOfInvitations',
  EVENT_ID = 'eventId',
  COUNTRY = 'Country',
}

export enum AdditionalChannelTabs {
  ALL_CHANNEL = 'all-channel',
}

export enum VisitTypeWithNoEngagement {
  NO_ENGAGEMENT = 'No Engagement',
  NO_WEB_INTERACTION = 'No Web Interaction',
  NOT_INVITED = 'No Invited',
  NOT_ATTENDED = 'No Attended',
  NO_EMAIL_OPENED = 'No email opened',
  NO_EMAIL_SENT = 'No email sent',
  NO_EMAIL_CLICKED = 'No email clicked',
  NO_1TO1_INTERACTION = 'No 1to1 interaction',
}

const visitTypeWithNoEngagementValues = new Set<string>(Object.values(VisitTypeWithNoEngagement));

export const isVisitTypeWithNoEngagement = (value: unknown): value is VisitTypeWithNoEngagement =>
  typeof value === 'string' && visitTypeWithNoEngagementValues.has(value);
